// Currently only supports boolean, string. Uncomment below to support number
var MediaUserPreferencesTypes = {
  videoCaptionsEnabled: 'boolean',
  videoCaptionsPreferredLocale: 'string'
};
/** Receives a generic UserPreferences interface and converts it to a strongly typed MediaUserPreferences interface */
export var generateMediaUserPreferences = function generateMediaUserPreferences(userPreferences) {
  return {
    set: function set(key, value) {
      userPreferences.set(key, value.toString());
    },
    get: function get(key) {
      var value = userPreferences.get(key);
      if (value === null || value === undefined) {
        return undefined;
      }
      if (MediaUserPreferencesTypes[key] === 'boolean') {
        return value === 'true';
      }
      // Uncomment to support number
      // if (MediaUserSettingsTypes[key] === 'number') {
      // 	return Number(value) as MediaSettingsTypeMap[K];
      // }
      return value;
    }
  };
};
var defaultUserPreferences = {
  set: function set(key, value) {
    var MEDIA_KEY = 'media';
    localStorage.setItem("".concat(MEDIA_KEY, "-").concat(key), value);
  },
  get: function get(key) {
    var MEDIA_KEY = 'media';
    return localStorage.getItem("".concat(MEDIA_KEY, "-").concat(key));
  }
};
export var defaultMediaUserPreferences = generateMediaUserPreferences(defaultUserPreferences);